import { gql } from "@apollo/client";
import { ReceiverInfoFragment } from "graphql/Receiver/fragments";
import { ActivityInfoFragment } from "graphql/User/fragments";

export const ParcelInfoFragment = gql`
  fragment ParcelInfo on Parcel {
    _id
    parcel_UID
    parcel_description
    parcel_size
    parcel_value
    parcel_amount_to_collect
    parcel_client_reference
    parcel_status
    parcel_return
    parcel_return_raison
    parcel_created_at
    parcel_last_edited_at
    parcel_delivery_date
    parcel_delivery_slot_start
    parcel_delivery_slot_end
    parcel_user_UID
    parcel_attempts
    parcel_additional_info
    isOutOfStock
    comment
    reason_UID
    parcel_reason {
      reason_name
    }
    pickupAddress {
      address
    }
    pickupMoreInfo {
      firstName
      lastName
      phoneNumber
    }
    service
    parcel_attempts_real
    parcel_order {
      _id
      order_UID
      order_status
      order_date
      order_time
      order_receiver {
        ...ReceiverInfo
      }
      order_validation_signature
      deliveryAddress {
        address
      }
    }
    parcel_activities {
      ...ActivityInfo
    }
    parcel_created_by {
      source
    }
    isThroughRelay
    isFromAPI
    relay {
      _id
      name
      code
      types
      phoneNumber
      openHour
      endHour
      users {
        first_name
        last_name
        roles {
          _id
          name
          description
          permissions {
            _id
            name
            description
          }
        }
      }
      location {
        country
        city
        region
        place_id
        address
        additional_address
        location {
          latitude
          longitude
        }
      }
    }
  }
  ${ReceiverInfoFragment}
  ${ActivityInfoFragment}
`;

export const ParcelSimpleInfoFragment = gql`
  fragment ParcelSimpleInfo on Parcel {
    _id
    parcel_UID
    parcel_description
    parcel_size
    parcel_value
    parcel_amount_to_collect
    parcel_client_reference
    parcel_additional_info
    parcel_status
    parcel_return
    parcel_return_raison
    parcel_created_at
    parcel_last_edited_at
    parcel_delivery_date
    parcel_user_UID
    parcel_attempts
    reason_UID
    relay {
      name
      types
      location {
        address
      }
    }
  }
`;

export const OderListFragment = gql`
  fragment OderSimpleInfo on Order {
    _id
    order_UID
    order_created_by {
      user_id
      source
    }
    order_status
    order_client_UID
    order_client {
      client_company_name
    }
    order_receiver {
      receiver_firstname
      receiver_lastname
      receiver_phone_number
      receiver_address {
        place_id
        country
        city
        region
        address
        additional_address
        location {
          latitude
          longitude
        }
      }
      receiver_entreprise
      receiver_specification_address
    }
    order_parcels {
      _id
      parcel_UID
      parcel_size
      parcel_value
      parcel_description
      parcel_amount_to_collect
      parcel_status
      parcel_return_raison
      parcel_created_at
      parcel_additional_info
    }
    order_job {
      job_type
      job_date
      job_time
      job_slot_start
      job_slot_end
      job_vehicle_type
      job_address {
        address
        place_id
      }
    }
    isThroughRelay
    isFromAPI
    relay {
      _id
      name
      code
      types
      phoneNumber
      openHour
      endHour
      users {
        first_name
        last_name
        roles {
          _id
          name
          description
          permissions {
            _id
            name
            description
          }
        }
      }
      location {
        country
        city
        region
        place_id
        address
        additional_address
        location {
          latitude
          longitude
        }
      }
    }
  }
`;
